module.exports = __webpack_public_path__ + "img/a2_1_E.081ba380.jpg";